import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useResendVerificationMutation } from "../slices/usersApiSlice";

export default function VerifyNoticeScreen() {
  const [primaryEmail, setPrimaryEmail] = useState("");
  const [resendVerification] = useResendVerificationMutation();

  const resendHandler = async () => {
    try {
      await resendVerification({ primaryEmail }).unwrap();
      toast.success("Success: Verification e-mail resent");
    } catch (err) {
      toast.error(err?.data?.message || "Error: Verification e-mail not sent");
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col xs={12} md={8} lg={6} className="text-center">
          <h1>Verify Your E-mail</h1>
          <p>Please, check your inbox for a verification link.</p>
          <p>Can't find the e-mail? If it's not in the Spam or Junk folder, try resending it below.</p>

          <div className="mt-4">
            <input
              type="email"
              placeholder="Enter your sign-up e-mail address"
              className="form-control"
              value={primaryEmail}
              onChange={(e) => setPrimaryEmail(e.target.value)}
            />

            <button className="btn btn-primary mt-3" onClick={resendHandler}>
              Resend Verification E-mail
            </button>
          </div>
        </Col>
      </Row>
    </Container>
  );
}